import { DefaultFetchService } from "app/services/fetchService";

import type { ClusterExplainationAnalysisDataResponse } from "../../common/types";

export const fetchDemandSpikeThreadID = (): Promise<{ threadId: string }> => {
    const fetchService = DefaultFetchService.getInstance();
    return fetchService.post<{ threadId: string }>("sse/market-research/demand-spike-agent/thread");
};

export const fetchDemandSpikeDrivingKWClusters = (
    threadId: string,
    keywordListId: string,
    spikeDate: string,
    country: string,
): Promise<ClusterExplainationAnalysisDataResponse> => {
    //https://antslangsmith-pro.sandbox.similarweb.com/sse/market-research/demand-spike-agent/spike-driving-keyword-groups/json?threadId=849b8b9c-4514-432f-b210-82e0a4f4c225&keywordListId=SearchTerm;trump&spikeDate=2024-07-01&country=840
    const fetchService = DefaultFetchService.getInstance();
    const endpoint = "sse/market-research/demand-spike-agent/spike-driving-keyword-groups/json";
    const queryParams = new URLSearchParams({
        threadId,
        keywordListId,
        spikeDate,
        country,
    });
    return fetchService.get(`${endpoint}?${queryParams.toString()}`);
};
